import { Icon } from "@mui/material";
import React from "react";

const CircleIcon: React.FC<{ icon: React.ReactNode }> = ({ icon }) => {
  return (
    <div style={{ position: "relative", display: "inline-block", width: "150px", height: "150px" }}>
      <Icon
        style={{
          backgroundColor: "#E1DCD5",
          borderRadius: "50%",
          position: "absolute",
          width: "150px",
          height: "150px",
          fontSize: "150px",
          left: 0,
          top: 0,
          zIndex: 0,
        }}
      />
      <div
        style={{
          position: "absolute",
          width: "150px",
          height: "150px",
          left: 0,
          top: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 1,
        }}
      >
        {icon}
      </div>
    </div>
  );
};

export default CircleIcon;
